import { createAsyncThunk } from "@reduxjs/toolkit";
import { getSflCaseDetails, updateSflCaseDetails } from "../../../../api/orgCaseDetails_api/sfl_caseDetails_api";

export const getSflCaseDetailsAction = createAsyncThunk(
  "case/getSflCaseDetailsAction",
  async (values, { rejectWithValue }) => {
    try {
      const result = await getSflCaseDetails(values);
      return result?.data ?? {};
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);

export const updateSflCaseDetailsAction = createAsyncThunk(
  "case/updateSflCaseDetailsAction",
  async (values, { rejectWithValue }) => {
    try {
      const result = await updateSflCaseDetails(values);
      return result;
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);
